import React from 'react';
import { toLanguageFromLocale } from '@peloton/internationalize/models/language';

import { Locale } from '@peloton/internationalize/models/locale';
import { getLocale } from '@engage/metadata';
import { useReduxState } from '@engage/redux';
import { getClassLanguagePreferences, getDisplayLanguage } from '@engage/settings';
import { isLanguageEnabled } from '@members/settings/ClassLanguages/localReducers';

type Props = {
  fitnessDisciplineName?: string;
  originLocale: Locale;
};

export const ClassInfoTag: React.FC<React.PropsWithChildren<Props>> = ({
  fitnessDisciplineName,
  originLocale = Locale.EnglishUnitedStates,
}) => {
  const classLanguagePreferences = useReduxState(getClassLanguagePreferences);
  const enabledLanguageCount = classLanguagePreferences.filter(isLanguageEnabled).length;
  const classLanguage = toLanguageFromLocale(originLocale);
  const classLanguageName = useReduxState(getLocale, originLocale);
  const displayLanguage = useReduxState(getDisplayLanguage);
  const shouldDisplayLanguage =
    enabledLanguageCount > 1 && classLanguage !== displayLanguage;
  return <>{shouldDisplayLanguage ? classLanguageName : fitnessDisciplineName}</>;
};
